import { Deferred, pipe } from '@helo/utils';
import { DataTypeConfigU } from './DataTypeConfig';
import { findDataTypeConfigBreadthFirst } from './DataTypeConfig.utils';
export const mapInputObjectConfig = (dataTypeConfigs, mappers) => (config) => {
    const mapFn = mapInputObjectConfig(dataTypeConfigs, mappers);
    if (config.kind === 'INPUT_OBJECT') {
        const mapper = mappers.find(m => m.sourceType === config.typeName);
        if (!mapper) {
            return {
                ...config,
                fields: config.fields.map(mapFn),
            };
        }
        const destinationConfig = dataTypeConfigs.find(c => c.kind === 'INPUT_OBJECT' && c.typeName === mapper.destinationType);
        if (!destinationConfig) {
            throw new Error(`Destination type "${mapper.destinationType}" not found in data type configs`);
        }
        if (destinationConfig.kind !== 'INPUT_OBJECT') {
            throw new Error(`Destination type "${mapper.destinationType}" is not an INPUT_OBJECT. It is a ${destinationConfig.kind}`);
        }
        const mappedFields = mapper.fields
            .map(fieldMapper => {
            const destField = destinationConfig.fields.find(f => f.key === fieldMapper.key);
            if (!destField) {
                return null;
            }
            try {
                const locatedConfig = findDataTypeConfigBreadthFirst(fieldMapper.locator, [])(config);
                const ofType = locatedConfig.kind === 'INPUT_VALUE'
                    ? mapFn(locatedConfig.ofType)
                    : locatedConfig;
                return DataTypeConfigU.createInputValueDataTypeConfig({
                    key: fieldMapper.key,
                    ofType,
                    isNullable: false,
                    directives: [],
                    state: {},
                    meta: {
                        path: [...(config.meta?.path ?? []), ['key', fieldMapper.key]],
                        unmappedPath: locatedConfig.meta?.unmappedPath ??
                            locatedConfig.meta?.path ??
                            [],
                    },
                });
            }
            catch (error) {
                return null;
            }
        })
            .filter((field) => field !== null);
        return DataTypeConfigU.createInputObjectDataTypeConfig({
            typeName: mapper.destinationType,
            fields: mappedFields,
            description: destinationConfig.description,
            isNullable: destinationConfig.isNullable,
            directives: destinationConfig.directives,
            state: pipe(destinationConfig.state ?? {}, Deferred.merge(config.state ?? {})),
            meta: {
                path: config.meta?.path ?? [],
                unmappedPath: config.meta?.unmappedPath ?? config.meta?.path ?? [],
            },
        });
    }
    switch (config.kind) {
        case 'INPUT_VALUE':
            return {
                ...config,
                ofType: mapFn(config.ofType),
            };
        case 'LIST':
            return {
                ...config,
                ofType: mapFn(config.ofType),
                items: config.items?.map(mapFn),
            };
        case 'FIELD':
            return {
                ...config,
                ofType: mapFn(config.ofType),
            };
        case 'OBJECT':
            return {
                ...config,
                fields: config.fields.map(f => mapFn(f)),
            };
        case 'UNION':
            return {
                ...config,
                possibleTypes: config.possibleTypes.map(mapFn),
            };
        case 'ENUM':
        case 'SCALAR':
        case 'TYPE_REFERENCE':
        case 'ENUM_VALUE':
        default:
            return config;
    }
};
export const InputObjectMapperUtils = {
    mapInputObjectConfig,
};
//# sourceMappingURL=DataTypeConfig-input-mapper.js.map